/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import http from "../http-common";

const controller = "/fleet";
class FleetService {

    async getpartnerfleet(partnerId) {
        // RIS migration: non-integer partnerId is a proCompanyId — route to the pro endpoint.
        // Integer partnerId keeps the legacy TT org-based route.
        const isProId = partnerId && isNaN(Number(partnerId));
        const response = isProId
            ? await http.get(`${controller}/bypro?proCompanyId=${encodeURIComponent(partnerId)}`)
            : await http.get(`${controller}/${partnerId}`);
        return response.data;
    }

    async getAll() {
        const response = await http.get(`${controller}`);
        return response?.data;
    }

}

export default new FleetService();
